<template>
	<div class="certificate-list">
		<b-row class="mb-3">
			<b-col cols="2" class="pr0">
				<b-form-select v-model="filter.sale"
							   :plain="false"
							   :required="true"
							   :text-field="'name'"
							   :value-field="'id'"
							   @change="typeChanged"
							   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

					<template slot="first">
						<option :value="null" disabled selected>
							--Выберите тип отчета--
						</option>
						<option value="sale">{{$t('sale.title')}}</option>
						<option value="byEmployee">{{$t('sidebar.organization-structure.employees')}}</option>
						<option value="spos">{{$t('sidebar.sales.sponsor')}}</option>
						<option value="QARZGA">{{$t('xAtchot.debt')}}</option>
					</template>
				</b-form-select>
			</b-col>
			<b-col cols="3" class="pr0" v-if="!isEmployee">
				<multiselect
					v-model="filter.depId"
					:options="listWarehouse"
					:multiple="true"
					@select="accept"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>
			<b-col cols="3" class="pr0" v-if="isEmployee">
				<multiselect 
						v-model="filter.employeeId"
						:options="employeesNoLinkedIds"
						:searchable="true"
						:custom-label="selectedOption"
						:show-labels="false"
						track-by="id"
						@search-change="loadItemsNoLinkedId($event)"
						@open="loadItemsNoLinkedId('')"
						:placeholder="$t('users-l.create.employee')">
			
				</multiselect>
			</b-col>
			<b-col cols="3" class="pr0" v-if="isEmployee">
				<multiselect
					v-model="filter.depId"
					:options="listWarehouseForEmployees"
					:multiple="true"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					label="name"
					:placeholder="$t('promo-to-product.department')"
					class="multiselect-pricing"
				>
				</multiselect>
			</b-col>
			<b-col cols="2" class="pr0" v-if="isSutochni">
				<b-form-select v-model="filter.type"
							   :plain="false"
							   :required="true"
							   :text-field="'name'"
							   :value-field="'id'"
							   @change="typeChanged"
							   data-errormessage-value-missing="Bu maydon to'ldirilishi shart!">

					<template slot="first">
						<option :value="null" disabled selected>
							--Выберите тип отчета--
						</option>
						<option value="daily">{{$t('sale.daily')}}</option>
						<option value="monthly">{{$t('sale.monthly')}}</option>
						<!--<option value="byEmployee">По сотруднику</option>-->
						<!--<option value="inDateRange">В диапазоне</option>-->
					</template>
				</b-form-select>
			</b-col>

			<date-picker v-model="filter.fromDate"  lang="ru" :placeholder=" $t('warehouse.date.start')" valueType="format"
						 format="DD-MM-YYYY"></date-picker>

			<date-picker v-model="filter.toDate" lang="ru" :placeholder="$t('warehouse.date.end')" valueType="format"
						 format="DD-MM-YYYY"></date-picker>
			<b-col cols="1">
				<b-button @click="searchReportClick" variant="primary"><i class="fa fa-search"></i></b-button>
			</b-col>
		</b-row>


		<hr>
	</div>
</template>

<script>
	import MaskedInput from 'vue-masked-input'
	import EmployeesService from "../../../../services/employees.service";
	import Multiselect from 'vue-multiselect'
	import {mapActions, mapGetters, mapState} from "vuex";

	export default {
		name: 'Filter-Pos-Report',

		components: {MaskedInput, Multiselect},
		props: ['employee'],
		data() {
			return {
				pageNoLinkedId:1,
				limitNoLinkedId:20,
				sendedName: '',
				departmentsForEmploye : [],
				selectedDepartment: [],
				filter: {
					depId: [],
					employeeId: null,
					fromDate: '',
					toDate: '',
					type: 'daily',
					sale: 'sale'

				},
				departmentArray: [],
				isDateRange: false,
				isEmployee: false,
				isSutochni: true,
				dropdowns: {
					counterparties: [],
				},
				attr: {}
			}
		},

		async mounted() {
			await this.getEmployeNoLinkedId(this.params)
			await this.fetchMyDepartments();
			await this.$emit('setSutochni', this.filter.type)
		},


		computed: {
			...mapGetters('departments', [
				'myDepartments'
			]),
			...mapState('employees', [ 'employeesNoLinkedIds']),
			params() {
				return {
					page: this.pageNoLinkedId,
					limit:this.limitNoLinkedId,
					name: this.sendedName
				}
			},
			listWarehouse() {
				return this.myDepartments.filter(item => {
					return item.typeName === 'COMPANY' || item.typeName === 'SHOP';
				})
			},
			listWarehouseForEmployees() {
				return this.departmentsForEmploye.filter(item => {
					return item.typeName === 'COMPANY' || item.typeName === 'SHOP';
				})
			}
		},
		methods: {
			...mapActions('employees', [ 'getEmployeNoLinkedId']),
			async loadItemsNoLinkedId($event) {
				this.sendedName = $event
				await this.getEmployeNoLinkedId(this.params)
			},
			selectedOption (c) {
				return c.firstName + ' ' + c.lastName
			},
			employeeSelectedOption(employee) {
				return employee.firstName + ' ' + employee.lastName;
			},
			searchReportClick() {
				this.filter.disabledTable = this.isEmployee;
				this.$emit('filter', this.filter)
			},
			...mapActions('departments', ['fetchMyDepartments']),
			accept() {

			},
			async loadEmploees(departments) {
				this.departmentArray = [];
				if (departments !== undefined) {
					departments.forEach(item => {
						this.departmentArray.push(item.id);
					})
				}
				let data = {
					page: 1,
					limit: 50,
					depIds: this.departmentArray
				}
				await EmployeesService.searchByDepsId(data).then(response => {
					this.dropdowns.counterparties = [];
					for (let i = 0; i < response.data.length; i++) {
						this.dropdowns.counterparties = [...response.data[i].items, ...this.dropdowns.counterparties];
					}
				})
			},
			async loadDepartments(employees) {
				await EmployeesService.getDepartmentsByEmployeeId(employees.id).then(response => {
					this.departmentsForEmploye = response.data
				})
			},
			typeChanged($event) {
				if ($event === 'byEmployee') {
					this.isEmployee = true
					this.isDateRange = true
					this.isSutochni = true;
				} else if ($event === 'inDateRange') {
					this.isEmployee = false
					this.isDateRange = true
				} else if ($event == 'sale') {
					this.isDateRange = true
					this.isSutochni = true
					this.isEmployee = false
					this.employeeId = null;
				} else if ($event == 'spos') {
					this.isDateRange = true
					this.isSutochni = true
					this.isEmployee = false
					this.employeeId = null;
				}else if (($event == 'daily' || $event == 'monthly') && this.isEmployee == true) {
					this.isEmployee = true
				} else {
					this.isEmployee = false
					this.isDateRange = false
				}
				this.$emit("disableTab",$event);
			}
		},
		watch: {
			'filter.type': {
				async handler(newVal) {
					await this.$emit('setSutochni', newVal)
				} 
			},	
			isEmployee : {
				handler() {
					this.filter.depId = []
				}
			},
			'filter.depId': {
				handler(newValue) {
					if(!this.isEmployee) {
						this.loadEmploees(newValue);
					}
				}
			},
			'filter.employeeId': {
				handler(newValue) {
					this.filter.depId = []
					if(newValue) {
						this.loadDepartments(newValue);
					}
				}
			}
		}

	}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
	.pr0 {
		padding-right: 0;
	}

	.mx-datepicker {
		padding-left: 20px;
	}
</style>
